import React from 'react'
import { Badge } from 'reactstrap'

export const checklistColumns = (layout, role, isStudent, onProgressChange, onDoneChange, slug, handleEdit) => [
	{
		name: 'Time Frame',
		selector: (row) => `${row.startMonth} - ${row.endMonth}`,
		sortable: true,
		center: true,
		width: '12%'
	},
	{
		name: 'Urgency',
		selector: (row) => row.urgency,
		sortable: true,
		center: true,
		width: '12%',
		cell: (row) => (
			<Badge color={row.urgency === 'Must' ? 'danger' : row.urgency === 'Should' ? 'warning' : 'info'} className="px-2 py-1">
				{row.urgency}
			</Badge>
		)
	},
	{
		name: 'Task',
		selector: (row) => row.pname,
		sortable: true,
		center: false,
		width: '20%',
		cell: (row) => <div className="text-start">{row.pname}</div>
	},
	{
		name: 'Date',
		selector: (row) => row.tDate,
		sortable: true,
		center: true,
		width: '12%'
	},
	{
		name: 'Done',
		selector: (row) => row.isDone,
		sortable: true,
		center: true,
		width: '10%',
		cell: (row) => <input type="checkbox" checked={row.isDone} onChange={() => onDoneChange(row.id, row.isDone)} disabled={!isStudent} />,
		ignoreRowClick: true,
		allowOverflow: true,
		button: true
	},
	{
		name: 'In Progress',
		selector: (row) => row.isProgress,
		sortable: true,
		center: true,
		width: '12%',
		cell: (row) => <input type="checkbox" checked={row.isProgress} onChange={() => onProgressChange(row.id, row.isProgress)} disabled={!isStudent} />,
		ignoreRowClick: true,
		allowOverflow: true,
		button: true
	},
	...(isStudent
		? []
		: [
				{
					name: 'Actions',
					selector: (row) => row.id,
					sortable: false,
					center: true,
					width: '20%',
					cell: (row) => (
						<div className="d-flex gap-1 justify-content-center">
							<button onClick={() => handleEdit(row)} className="btn btn-success btn-sm">
								<i className="fa fa-edit me-1"></i>
							</button>
							<button className="btn btn-danger btn-sm" onClick={() => row.onDelete(row.id)}>
								<i className="fa fa-trash"></i>
							</button>
						</div>
					),
					ignoreRowClick: true
				}
		  ])
]

export const checklistCustomHeader = (searchQuery, setSearchQuery, slug, layout, role, isStudent, onAddTask) => (
	<div className="d-flex align-items-center gap-3">
		<input
			type="text"
			placeholder="Search checklist items..."
			value={searchQuery}
			onChange={(e) => setSearchQuery(e.target.value)}
			className="form-control"
			style={{ width: '300px' }}
		/>
		{!isStudent && (
			<button onClick={onAddTask} className="btn btn-primary btn-sm">
				<i className="fa fa-plus me-1"></i>
				Add Item
			</button>
		)}
	</div>
)
